// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3nIKp","content":"Consent_content__2XTe6","footer":"Consent_footer__3GB0l"};